import { connect } from 'react-redux';
import { KnowledgeLinkEditorComponent } from './knowledge-link-editor.component';
import { createKnowledgeLink } from 'shared/store/actions/knowledge.items.actions';

const mapStateToProps = state => ({
  lang: state.lang.KNOWLEDGE_LINK_EDITOR,
});

export const KnowledgeLinkEditor = connect(mapStateToProps, { createKnowledgeLink })(
  KnowledgeLinkEditorComponent,
);
